/* shared/overlays — global overlay components.
   ─────────────────────────────────────────────────────────────
   Phase 1 scope: ConfirmModal (extracted from services.jsx). It is fully
   self-contained — depends only on shared/state + shared/ui.

   DEFERRED to the Step 1 ↔ Step 2 boundary (documented blocker):
     RecordDrawer, Copilot, CopilotRich, resolveCopilotIntent, CommandPalette,
     Timeline (currently in the prototype's overlays.jsx).

   Reason: RecordDrawer renders the workspace-tier record-detail tabs
   (person-detail / company-detail / deal-detail) and crm-functional panels
   (RelationshipsPanel, DocumentsTab, CompanyAnalyticsPanel, BFSI props).
   Those live in the Workspace tier and are NOT converted in Phase 1. Moving
   RecordDrawer now would either pull workspace files into the shared layer
   (a tier violation) or produce a broken module. They will be converted with
   the Workspace records module in Step 2 and re-homed here per the approved
   File Movement Plan. */
import React, { useEffect } from 'react';
import { NexusIcon } from '../ui/NexusIcon';
import { Btn } from '../ui';
import { useStore } from '../state';

/* ---------- ConfirmModal — driven by store.confirm() ---------- */
export const ConfirmModal = () => {
  const store = useStore();
  const cfg = store.confirmState;
  useEffect(() => {
    if (!cfg) return;
    const onKey = (e) => { if (e.key === 'Escape') store.closeConfirm(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [cfg, store]);
  if (!cfg) return null;
  return (
    <div className="nx-cmd-veil" style={{ alignItems: 'center', zIndex: 80 }} onClick={store.closeConfirm}>
      <div className="nx-confirm" onClick={e => e.stopPropagation()}>
        <div className={'nx-confirm-icon' + (cfg.danger ? ' is-danger' : '')}>
          <NexusIcon name="AlertCircle" size={18} />
        </div>
        <h3 className="nx-confirm-title">{cfg.title || 'Are you sure?'}</h3>
        {cfg.description && <p className="nx-confirm-desc">{cfg.description}</p>}
        <div className="nx-confirm-actions">
          <Btn variant="ghost" onClick={store.closeConfirm}>{cfg.cancelLabel || 'Cancel'}</Btn>
          <Btn variant={cfg.danger ? 'danger' : 'primary'} icon={cfg.danger ? 'Trash' : 'Check'} onClick={() => { cfg.onConfirm && cfg.onConfirm(); store.closeConfirm(); }}>
            {cfg.confirmLabel || (cfg.danger ? 'Delete' : 'Confirm')}
          </Btn>
        </div>
      </div>
    </div>
  );
};
